export enum AtiraLinkThemes {
  BASIC = 'BASIC',
  URANUS = 'URANUS',
  HOTH = 'HOTH',
  EGO = 'EGO',
  EARTH = 'EARTH',
  MERCURY = 'MERCURY',
  JUPITER = 'JUPITER',
  MARS = 'MARS',
  NEPTUNE = 'NEPTUNE',
  SATURN = 'SATURN',
  THERA = 'THERA',
  MOON = 'MOON',
  GLIESE = 'GLIESE',
  KEPLER = 'KEPLER',
  VIOLA = 'VIOLA',
  CERULEAN = 'CERULEAN',
  ENCELADUS = 'ENCELADUS',
  DIMIDUM = 'DIMIDUM',
  OSIRIS = 'OSIRIS',
  CANCRI = 'CANCRI',
  EUROPA = 'EUROPA',
  VULCANO = 'VULCANO',
  CALLISTO = 'CALLISTO',
  AZURE = 'AZURE',
  CERES = 'CERES',
  MIMAS = 'MIMAS',
  PROXIMA = 'PROXIMA',
  PLUTO = 'PLUTO',
  HAUMEA = 'HAUMEA',
  PHOBOS = 'PHOBOS',
  GENYMADE = 'GENYMADE',
  ERIS = 'ERIS',
  TRITON = 'TRITON',
  OBERON = 'OBERON',
  HYPERION = 'HYPERION',
  VESTA = 'VESTA',
  SIRIUS = 'SIRIUS',
  ARIEL = 'ARIEL',
  ONYX = 'ONYX',
  ALCYONE = 'ALCYONE',
  COBALT = 'COBALT',
  SOLSTICE = 'SOLSTICE',
  AQUARIUS = 'AQUARIUS',
  ZENITH = 'ZENITH',
  ABYSS = 'ABYSS',
  FUCHSIA = 'FUCHSIA',
  CRIMSON = 'CRIMSON',
  LYRA = 'LYRA',
  NOVA = 'NOVA',
  ORION = 'ORION',
  SYLVA = 'SYLVA',
  VORTEX = 'VORTEX',
  ARCTURUS = 'ARCTURUS',
  NEBULA = 'NEBULA',
  VEYRA = 'VEYRA',
  THALASSA = 'THALASSA',
  XANTHE = 'XANTHE',
  VALTOR = 'VALTOR',
  LUMINIS = 'LUMINIS',
  ZENARA = 'ZENARA',
  ELYSIUM = 'ELYSIUM',
  VIRIDIAN = 'VIRIDIAN',
  CLYRA = 'CLYRA',
  SOLARA = 'SOLARA',
  TALOS = 'TALOS',
  AETHRA = 'AETHRA',
  ORPHEUS = 'ORPHEUS',
  CYGNUS = 'CYGNUS',
  METIS = 'METIS',
  ELARA = 'ELARA',
  THEBE = 'THEBE',
  PALLAS = 'PALLAS',
  ANTHE = 'ANTHE',
  HYGIEA = 'HYGIEA',
  DIONE = 'DIONE',
  DESDEMONA = 'DESDEMONA',
  MIRANDA = 'MIRANDA',
  CORVAX = 'CORVAX',
  VIRELIA = 'VIRELIA',
  TAURIS = 'TAURIS',
  ORVION = 'ORVION',
  THANDROS = 'THANDROS',
  AURALIS = 'AURALIS',
  ILLYRA = 'ILLYRA',
  AVENAR = 'AVENAR',
  DRAVON = 'DRAVON',
  TESSARA = 'TESSARA',
  CHARON = 'CHARON',
  VENUS = 'VENUS',
  MAKEMAKE = 'MAKEMAKE',
  SEDNA = 'SEDNA',
  ORCUS = 'ORCUS',
  GONGGONG = 'GONGGONG',
  QUAOAR = 'QUAOAR',
  DEIMOS = 'DEIMOS',
  JENUS = 'JENUS',
  CARME = 'CARME',
  NESO = 'NESO',
  CHAOS = 'CHAOS',
  VARUNA = 'VARUNA',
  IXION = 'IXION',
  ALBION = 'ALBION',
}
